import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ReactSVG } from 'react-svg';
import { IconSvg } from '../../../../../utils/globalIcons';
import { getStyles } from './styles';
import AnalyticsApi from '../../../../../Api/Services/AmeyaBackend/AnalyticsToolApi';
import LoadBar from '../../../../../utils/LoadBar';
import { tostAlert } from '../../../../../utils/AlertToast';
import { formatLabel } from '../../../../../utils';
import { useIntl } from 'react-intl';
import messages from '../messages';

function AmeyaExtract({ setAmeyaExtractData, ameyaExtractData }) {
    const theme = useTheme();
    const styles = getStyles(theme);
    const intl = useIntl();

    const handleTestConnection = async () => {
        setAmeyaExtractData(prev => ({ ...prev, loading: true }));
        try {
            setAmeyaExtractData(prev => ({ ...prev, connectionStatus: "" }));
            const reqObj = { uri: ameyaExtractData.connectionMongoUri };
            const response = await AnalyticsApi.mongoConnectionDBLists(JSON.stringify(reqObj));

            if (response.status === 200) {
                setAmeyaExtractData(prev => ({ ...prev, connectionStatus: "success" }));
            } else {
                setAmeyaExtractData(prev => ({ ...prev, connectionStatus: "failed" }));
            }

        } catch (error) {
            console.log(error);
            setAmeyaExtractData(prev => ({ ...prev, connectionStatus: "failed" }));
            tostAlert(intl.formatMessage(messages.connection_error), 'error');
        } finally {
            setAmeyaExtractData(prev => ({ ...prev, loading: false }));
        }
    }

    return (
        <Box>

            {ameyaExtractData.loading && <LoadBar />}

            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Typography sx={{ fontSize: '14px', fontWeight: '400' }}>Connection Name : </Typography>
                <Typography sx={{ fontSize: '14px', fontWeight: '600' }}>{(formatLabel(ameyaExtractData.connectionName))}</Typography>
            </Box>

            {/* <Box marginTop={'20px'}>
                <Typography mb={1}>Connection String</Typography>
                <TextField
                    variant="outlined"
                    type="text"
                    size='medium'
                    disabled
                    sx={{ width: '600px' }}
                    value={ameyaExtractData.connectionMongoUri}
                />
            </Box> */}

            <Box sx={{ display: 'flex', alignItems: 'center', gap: '50px', marginTop: '10px' }}>

                <Typography
                    onClick={handleTestConnection}
                    sx={{
                        fontSize: '14px', fontWeight: '600', color: '#0B51C5', cursor: 'pointer',
                        '&:hover': { textDecoration: 'underline' }
                    }}
                >
                    TEST CONNECTION
                </Typography>
                {ameyaExtractData.connectionStatus === "success" &&
                    <Box display={'flex'} alignItems={'center'} flexDirection={'row'} gap={'7px'}>
                        <ReactSVG
                            src={IconSvg.plugConnectedIcon}
                            beforeInjection={(svg) => {
                                svg.setAttribute('style', 'width:24px; height:24px; display:block;');
                                svg.setAttribute('stroke', '#1BA559');
                            }}
                        />
                        <Typography sx={styles.paraText}>Connection successful</Typography>
                    </Box>
                }

                {ameyaExtractData.connectionStatus === "failed" &&
                    <Box display={'flex'} alignItems={'center'} flexDirection={'row'} gap={'7px'}>
                        <ReactSVG
                            src={IconSvg.plugNotConnectedIcon}
                            beforeInjection={(svg) => {
                                svg.setAttribute('style', 'width:24px; height:24px; display:block;');
                                svg.setAttribute('stroke', '#E00000');
                            }}
                        />
                        <Typography sx={styles.paraText}>Unable to connect</Typography>
                    </Box>
                }
            </Box>

        </Box>
    )
}


export default AmeyaExtract;